module.exports = __webpack_public_path__ + "img/blue_092.2ef3cfcb.png";